import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
  useDebounce,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useQueryRequest } from './QueryRequestProvider'
import { useListFilters } from './ListFiltersProvider'
import { useModal } from '../../../../../components'
import { getFaturasByEmpresa } from './_requests'
import { FaturaList } from '../../faturas-list/core/_models'

const QueryResponseContext = createResponseContext<FaturaList>(initialQueryResponse)
export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()
  const { filters } = useListFilters()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  // A instituição vai na URL do endpoint. Com o mesmo debounce da busca, URL e `search` mudam
  // juntos (sem uma requisição intermediária com a instituição nova e o filtro antigo).
  const idEmpresa = useDebounce(filters.empresa, 500)?.value
  const enabled = !isOpen && !!idEmpresa

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    [QUERIES.FATURAS_RESPONSAVEL_LIST, idEmpresa, query],
    () => getFaturasByEmpresa(Number(idEmpresa), query),
    {
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      enabled,
    }
  )

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
